import { useTranslation } from 'react-i18next';
import { cn } from '@c2fo/liquidity';
import { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import { Agreement } from '@/enterprise/features/agreements/Agreement';
import { useReporting } from '@/reporting';
import QueryBoundaries from '@/shared/components/QueryBoundaries';

interface ConfirmAgreementsProps {
  checked: boolean;
  disabled: boolean;
  hasError: boolean;
  onChange: (v: boolean) => void;
  takersMarkets: TakerMarket[];
  variant: 'light' | 'dark';
}

const ConfirmAgreements = ({
  checked,
  disabled,
  hasError,
  onChange,
  takersMarkets,
  variant,
}: ConfirmAgreementsProps) => {
  const { t } = useTranslation();
  const { trackEnterpriseEvent } = useReporting();

  const handleChange = (value: boolean) => {
    trackEnterpriseEvent('offer-builder::agreement::toggled');

    onChange(value);
  };

  return (
    <QueryBoundaries>
      <div>
        <div
          className={cn('rounded-md border border-transparent p-2', {
            'bg-white/10': variant === 'light',
            'border-red-400': variant === 'light' && hasError,
            'border-red-500': variant === 'dark' && hasError,
          })}
        >
          <Agreement
            checked={checked}
            disabled={disabled}
            onChange={handleChange}
            takersMarkets={takersMarkets}
            variant={variant}
          />
        </div>
        {hasError && (
          <div className={cn('pt-1 text-sm text-red-400', { 'text-red-600': variant === 'dark' })}>
            {t('builder.agreementsErrorMessage')}
          </div>
        )}
      </div>
    </QueryBoundaries>
  );
};

export default ConfirmAgreements;
